import * as _ from 'lodash';
import urlParamManager from './urlParamManager';
import * as masters from '../components/masterComponents';
import RoanUtility from '../utilities/roanUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';

/**
 *
 */
class masterSlideLoader {
  constructor() {
    this.delegate = [];
    this.masterslide = null;
    this.state = {
      state: {},
      url: SessionStorageService.getItem('url'),
    };

    //urlの変更は直接うけて描画する

    // eslint-disable-next-line no-unused-vars
    urlParamManager.setDelegate((split, masterslide, slide) => {
      this.masterslide = masterslide;
      this.publishView();
    });
  }

  /**
   * コンポーネントを返す
   */
  show(slidename, state) {
    //変更をプッシュステートする
    urlParamManager.setMaster(slidename, state);

    if (_.isUndefined(masters[slidename])) {
      console.warn(`masterSlideLoader.js show slidename:${slidename}`, masters);
    }

    this.setView(masters[slidename], state);
  }

  /**
   * マスタースライドを閉じる
   * 労務安全画面から呼び出された画面の場合には
   * SessionStorageの'url'が設定されているので、
   * 閉じる時に設定されたURLに戻るように実装されている
   * マスター管理系画面やアカウント詳細編集画面の「×」ボタン用
   */
  close() {
    // console.log('masterSlideLoader.js close');

    //SessionStorageからURLを取得
    let url = SessionStorageService.getItem('url');
    let urlTracker = SessionStorageService.getItem('url_tracker');
    //労安または車両管理から遷移してきた時の分岐
    if (url === null && urlTracker === null) {
      //変更をプッシュステートする
      urlParamManager.setMaster(false);

      //urlを変更する
      this.setView(null, null);
    } else if (url) {
      //✕ボタンで閉じる場合sessionStorageのURLを見て労安へ戻る
      RoanUtility.setSessionSelectedPartnerCompanyIdBeforeMoveRoan();
      SessionStorageService.removeLastCheckedTimeOfExpiration();
      window.location.href = url;
      sessionStorage.removeItem('url');
    } else if (urlTracker) {
      window.location.href = urlTracker;
      sessionStorage.removeItem('url_tracker');
    }
  }

  /**
   * urlから受けたパラメータからスライドを開く
   * リロード時に画面を再表示するときに使われる
   */
  publishView() {
    // console.log('masterSlideLoader.js publishView');

    if (!this.masterslide) {
      return;
    }

    const param = this.masterslide.split(':');
    let props = {
      state: param[1] ? { id: param[1] } : {}, //編集id
    };

    if (this.masterslide) {
      this.setView(masters[param[0]], props);
    } else {
      this.setView(null, null);
    }
  }
}

const _masterSlideLoader = new masterSlideLoader();
export default _masterSlideLoader;



// WEBPACK FOOTER //
// ./src/utilities/masterSlideLoader.js